
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';
import $ from 'jquery';

import { ending_bg } from '../../index.const';

import StageBaseController from '../stage-base.controller';

export default class EndingController extends StageBaseController {
    constructor($log, $state, $window, $timeout, $Fabric, $interval, Dialog, Session) {
        'ngInject';
        super($log, $state, $timeout, $interval, Dialog, Session, 1);
        this.ending_bg = ending_bg;
        this.$Fabric = $Fabric;
        this.$window = $window;

        this.state = {
            step: 0
        }
    }

    $onInit() {
        let data = this.Session.get();
        if (!_.isEmpty(data)) {
            this.stages = this.Session.get().stages;
            this.keys = this.Session.getKeys();
        }

        this.dialogText = [
            { bg: this.ending_bg[0], dialog: "Pronto! Agora você está apto <br> a entrar na nave para visitar o <strong>planeta Tetrix</strong>.", direction: "out" },
            { bg: this.ending_bg[9], dialog: false, direction: null },
            { bg: this.ending_bg[2], dialog: "Nós já estamos quase chegando ao <br/><strong>planeta Tetrix</strong>.", direction: "out" },
            { bg: this.ending_bg[1], dialog: "Nossa! <br/> Que planeta mais diferente!", direction: "in" },
            { bg: this.ending_bg[9], dialog: false, direction: null },
            { bg: this.ending_bg[3], dialog: "Essa viagem foi muito divertida. <br/> Ir ao <strong>planeta Tetrix</strong> foi mesmo <br/> uma experiência única.", direction: "in" },
            { bg: this.ending_bg[4], dialog: "Conheci pessoas muito diferentes das <br/> existentes na Terra. Seus corpos <br/> tinham o <strong>formato geométrico</strong>.", direction: "in" },
            { bg: this.ending_bg[5], dialog: "No <strong>planeta Tetrix</strong>, até os animais eram na forma de <strong>Tangram</strong>.", direction: "in" },
            { bg: this.ending_bg[6], dialog: "E suas construções e elementos da natureza eram baseados em <strong>sólidos espaciais</strong>.", direction: "in" },
            { bg: this.ending_bg[7], dialog: false, direction: null },
            { bg: this.ending_bg[8], dialog: false, direction: null }
        ]

        this.endScreen = false;
    }

    hasDialog(val) {
        if (val !== false)
            return true;
        else
            return false;
    }

    resetGame() {
        if (!_.isEmpty(this.Session.get())) {
            this.$window.location.reload(true);
            this.Session.destroy();
        }
    }

    nextStep() {
        this.$log.log('goes to next step', this.state.step)

        if (this.state.step === 9) {
            this.state.step = this.state.step;
        } else if (this.state.step < this.dialogText.length - 2) {

            switch (this.state.step) {
                case 0:
                    $(`div.ending-step.step#${this.state.step}`).fadeOut(300, 'linear', () => { this.state.step += 1 });
                    this.$log.log(`step: ${this.state.step}`);
                    break;

                case 3:
                    $(`div.ending-step.step#${this.state.step}`).fadeOut(200, 'linear', () => { this.state.step += 1 });
                    this.$log.log(`step: ${this.state.step}`);
                    break;

                case 8:
                    $(`div.ending-step.step#${this.state.step}`).fadeOut(200, 'linear', () => { this.state.step += 1 });
                    break;

                default:
                    this.state.step += 1;
                    break;
            }

            this.$log.log('finish to next step', this.state.step)
            this.$timeout(() => this.checkDialog(this.state.step), 400);
        }
    }

    checkDialog(i) {
        this.$log.log('step', this.state.step)
        this.$log.log('it has dialog', this.hasDialog(this.dialogText[i].dialog))
        if (!this.hasDialog(this.dialogText[i].dialog)) {

            $(`div.ending-step.step#${i}`).fadeIn(400, "linear", () => {
                this.$log.log(this.state.step);
            });

            this.$timeout(() => {
                this.state.step += 1;
            }, 600);

            if (this.state.step < 9) {
                $(`div.ending-step.step#${this.state.step}`).fadeIn(250, "linear");
                this.$log.log(`sem diálogo: ${this.state.step}`);
            }

        } else {

            if (i === 8) {
                $(`div.ending-step.step#${i + 1}`).fadeIn(250, "linear");
            } else {
                $(`div.ending-step.step#${this.state.step + 1}`).fadeIn(250, "linear");
                this.$log.log(`com diálogo: ${this.state.step}`);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/ending/ending.controller.js